import validatePlateNumber from "utils/validatePlateNumber";
import { RefinementCtx, ZodIssueCode, string } from "zod";

import { INVALID_REGISTRATION_MESSAGE } from "./validationMessages";

const regNumberInputValidationSchema = string()
    .trim()
    .transform((value: string, ctx: RefinementCtx): string => {
        if (!value) {
            ctx.addIssue({
                code: ZodIssueCode.custom,
                message: INVALID_REGISTRATION_MESSAGE,
            });
        }

        const { isValid } = validatePlateNumber(value);

        if (!isValid) {
            ctx.addIssue({
                code: ZodIssueCode.custom,
                message: INVALID_REGISTRATION_MESSAGE,
            });
        }

        return value;
    });

export default regNumberInputValidationSchema;
